import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading";
import Alert from "@/components/scan/parts/Alert.vue";
import ManualInfoDataService from "@/services/ManualInfoDataService";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("Category Edit");
const modalSubject = reactive([]);
const categoryModalBody = reactive([]);
const categoryInfo = reactive([]);
const getData = ref(false);
const activeUserId = ref();
const manualInfo = reactive([]);

const categoryName = ref("");
const oldCategoryName = ref("");
const categoryOrder = ref("");
const cateName = ref("");
const cateOrder = ref("");
const errCategoryOrder = ref("");
const errCategoryName = ref("");

/** 初期表示設定 */
onMounted(function () {
  isLoading.value = true;
  //getManualList();
  getCategoryList();
});

/** Get Manual List */
const getManualList = () => {
  isLoading.value = true;
  manualInfo.splice(0);
  const data = {};

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // get Manual Data
  ManualInfoDataService.getManualEdit(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        for (let info of response.data) {
          manualInfo.push(info);
        }
      }
      getData.value = true;
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err040");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** Get Category List */
const getCategoryList = () => {
  isLoading.value = true;
  categoryInfo.splice(0);
  const data = {};

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // get Category Data
  ManualInfoDataService.getCategory(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        for (let info of response.data) {
          categoryInfo.push(info);
        }
      }
      getData.value = true;
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err041");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** update Category List */
const updateCategoryList = () => {
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  var err = false;
  var chkManualErr = false;

  if (!inputCheck()) {
    return;
  }

  const data = {
    name: categoryName.value,
    categoryOrder: categoryOrder.value,
    oldCategoryName: oldCategoryName.value,
  };

  clearMsg();

  ManualInfoDataService.getManualEdit(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        for (let info of response.data) {
          manualInfo.push(info);
        }
      }
      if (oldCategoryName.value != categoryName.value) {
        for (var info2 = 0; info2 < manualInfo.length; info2++) {
          if (manualInfo[info2].category == oldCategoryName.value) {
            chkManualErr = true;
          }
        }
      }
      if (chkManualErr) {
        document.getElementById("modalCancel").click();
        alertMessage.value = i18n.t("err045");
        alertState.value = "error";
        isLoading.value = false;
      } else {
        if (isNaN(categoryOrder.value)) {
          errCategoryOrder.value = i18n.t("alt058");
          return;
        }
        if (oldCategoryName.value != categoryName.value) {
          for (var info1 = 0; info1 < categoryInfo.length; info1++) {
            if (categoryInfo[info1].category == categoryName.value) {
              err = true;
            }
          }
        }
        if (err) {
          errCategoryName.value = i18n.t("alt059");
          return;
        } else {
          document.getElementById("modalCancel").click();
          // update Category Data
          ManualInfoDataService.updateCategoryInfo(data)
            .then((response: ResponseData) => {
              getCategoryList();
              alertMessage.value = i18n.t("suc013");
              alertState.value = "success";
              isLoading.value = false;
            })
            .catch((e: Error) => {
              console.log(e);
              alertMessage.value = i18n.t("err039");
              alertState.value = "error";
              isLoading.value = false;
            });
        }
      }
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err040");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** add category List */
const addCategoryList = () => {
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  const data = { name: cateName.value, categoryOrder: cateOrder.value };

  var chkName = cateName.value;
  var chkOrder = cateOrder.value;
  var err = false;

  for (var info = 0; info < categoryInfo.length; info++) {
    if (categoryInfo[info].category == chkName) {
      alert("Category name is existing.");
      isLoading.value = false;
      err = true;
    }
  }

  if (!err) {
    if (chkName == "" || chkOrder == "") {
      alert("Please Fill Category Name & Category Order!");
      isLoading.value = false;
    } else if (isNaN(chkOrder)) {
      alert("Please Type integer Category Order!");
      isLoading.value = false;
    } else {
      // add category Data
      ManualInfoDataService.addCategoryInfo(data)
        .then((response: ResponseData) => {
          cateName.value = "";
          cateOrder.value = "";
          getCategoryList();
          alertMessage.value = i18n.t("suc009");
          alertState.value = "success";
          isLoading.value = false;
        })
        .catch((e: Error) => {
          console.log(e);
          alertMessage.value = i18n.t("err037");
          alertState.value = "error";
          isLoading.value = false;
        });
    }
  }
};

/** delete Category List */
const deleteCategoryList = (param) => {
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  var err = false;

  const data = { categoryName: param };

  ManualInfoDataService.getManualEdit(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        for (let info of response.data) {
          manualInfo.push(info);
        }
      }
      for (var info1 = 0; info1 < manualInfo.length; info1++) {
        if (manualInfo[info1].category == param) {
          alertMessage.value = i18n.t("err045");
          alertState.value = "error";
          isLoading.value = false;
          err = true;
          return;
        }
      }
      if (!err) {
        if (confirm(i18n.t("cnf005"))) {
          // delete Category Data
          ManualInfoDataService.deleteCategoryInfo(data)
            .then((response: ResponseData) => {
              alertMessage.value = i18n.t("suc021");
              alertState.value = "success";
              activeUserId.value = param;
              // クリックしたユーザーを承認対象ユーザーから削除する
              for (var i = 0; i < categoryInfo.length; i++) {
                if (categoryInfo[i].category == activeUserId.value) {
                  categoryInfo.splice(i, 1);
                  i = i - 1;
                }
              }
              isLoading.value = false;
            })
            .catch((e: Error) => {
              console.log(e);
              alertMessage.value = i18n.t("err038");
              alertState.value = "error";
              isLoading.value = false;
            });
        } else {
          isLoading.value = false;
        }
      }
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err040");
      alertState.value = "error";
      isLoading.value = false;
    });
};

onUpdated(function () {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var mydivh = document.getElementById("mydiv")?.clientHeight;
      tableHeight = mydivh - 44;
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
});

const inputCheck = () => {
  var err = false;
  clearMsg();

  if (categoryName.value == "") {
    errCategoryName.value = i18n.t("alt054");
    err = true;
  }
  // 2023/05/19 MDCR 修正 start(==から===、0と""の比較でTrueになることの修正)
  if (categoryOrder.value === "") {
    errCategoryOrder.value = i18n.t("alt055");
    err = true;
  }
  // 2023/05/19 MDCR 修正 end

  if (err) {
    return false;
  } else {
    return true;
  }
};

const clearMsg = () => {
  errCategoryOrder.value = "";
  errCategoryName.value = "";
};

/** Edit category */
const modalShow1 = (param) => {
  modalSubject.splice(0);
  categoryModalBody.splice(0);
  modalSubject.push("Edit Category");

  clearMsg();

  for (var info = 0; info < categoryInfo.length; info++) {
    if (categoryInfo[info].category == param) {
      categoryName.value = categoryInfo[info].category;
      oldCategoryName.value = categoryInfo[info].category;
      categoryOrder.value = categoryInfo[info].categoryOrder;
    }
  }
};

/** back button */
const backbtnEvt = () => {
  store.dispatch("setShowPage", "ManualEdit");
};

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, modalSubject, categoryModalBody, categoryInfo, getData, activeUserId, manualInfo, categoryName, oldCategoryName, categoryOrder, cateName, cateOrder, errCategoryOrder, errCategoryName, getManualList, getCategoryList, updateCategoryList, addCategoryList, deleteCategoryList, inputCheck, clearMsg, modalShow1, backbtnEvt, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})